import * as React from 'react';

interface Props {
  className?: string;
}

const AddParticipantIcon: React.FC<Props> = ({ className }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 10L11 10C13.7614 10 16 12.2386 16 15C16 15.5523 15.5523 16 15 16C14.4872 16 14.0645 15.614 14.0067 15.1166L13.9949 14.8237C13.907 13.3072 12.6928 12.093 11.1763 12.0051L11 12L5 12C3.34315 12 2 13.3431 2 15C2 15.5523 1.55228 16 1 16C0.447715 16 0 15.5523 0 15C0 12.3112 2.12231 10.1182 4.78311 10.0046L5 10ZM8 0C8.55229 0 9 0.447715 9 1C9 1.55228 8.55229 2 8 2C6.34315 2 5 3.34315 5 5C5 6.65685 6.34315 8 8 8C8.74154 8 9.43872 7.73127 9.98328 7.25098C10.3975 6.88566 11.0294 6.92529 11.3947 7.33949C11.76 7.75369 11.7204 8.38562 11.3062 8.75093C10.3997 9.55045 9.23342 10 8 10C5.23858 10 3 7.76142 3 5C3 2.23858 5.23858 0 8 0ZM13 0C13.5523 0 14 0.447715 14 1V2L15 2C15.5523 2 16 2.44772 16 3C16 3.55228 15.5523 4 15 4H14V5C14 5.55228 13.5523 6 13 6C12.4477 6 12 5.55228 12 5V4L11 4C10.4477 4 10 3.55228 10 3C10 2.44772 10.4477 2 11 2L12 2V1C12 0.447715 12.4477 0 13 0Z"
      fill="#187A90"
    />
  </svg>
);

export default AddParticipantIcon;
